import React from "react";
import { Input } from "antd";
import TrebbleConfigProvider from "./ConfigProvider";
import useDefaultTrebbleAntDTokenConfig from "../helper/useDefaultTrebbleAntDTokenConfig";

interface TrebbleInputProps extends React.ComponentProps<typeof Input> {
  useEditorTheme?: boolean;
}

const TrebbleInputComponent = ({ useEditorTheme, ...restProps }: TrebbleInputProps) => {
  const themeConfig = useDefaultTrebbleAntDTokenConfig({ useEditorTheme });

  return (
    <TrebbleConfigProvider theme={themeConfig} useEditorTheme={useEditorTheme}>
      <Input {...restProps} />
    </TrebbleConfigProvider>
  );
};

// Re-exporting sub-components
TrebbleInputComponent.TextArea = Input.TextArea;
TrebbleInputComponent.Search = Input.Search;
TrebbleInputComponent.Group = Input.Group;
TrebbleInputComponent.Password = Input.Password;

// Type assertion
const TrebbleInput = TrebbleInputComponent as typeof TrebbleInputComponent & {
    TextArea: typeof Input.TextArea;
    Search: typeof Input.Search;
    Group: typeof Input.Group;
    Password: typeof Input.Password;
};

export default TrebbleInput; 